import React from "react";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import { connect } from "react-redux";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import history from "../../auth/history";
import { store } from "../../redux/store";
import { setBatch, setStartDate } from "../../redux/misc-data/misc-data.action";
import tokenErrorHandler from "../tokenErrorHandler";
import { Link } from "react-router-dom";
const httpClient = axios.create();
class Payment extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,

		}
	}


	componentDidMount() { }
	componentWillUnmount() {
	}


	paymentDetails = (event) => {
		event.preventDefault();
		if (this.props.selectedConsumers != undefined &
			this.props.selectedConsumers.length > 0) {
			var requesterId = this.props.clientRequesterId;

			this.setState({
				progress: 'started'
			})

			const haeder = {
				msgType: "CREATE_ORDER",
				service: "BILLPAY",
				src: "create-order",
				dst: "create-order",
				channel: "WEB",
				requesterId: requesterId,
				requestId: uuidv4(),
				traceId: uuidv4(),
			}



			var request = {
				header: haeder,
				consumerList: this.props.selectedConsumers,
				agentId: this.props.agentInfo,
				device: this.props.deviceInfo
			}


			const url = "/api/v1/billpay/corp/consumer/process-orders";

			const headers = {
				'Authorization': 'Bearer ' + this.props.token,
				'client-id': this.props.agentInfo,
				'role': this.props.clientRole
			}


			httpClient.post(url, request,
				{ headers }
			).then((response) => {
				console.log('response:' + JSON.stringify(response.data));
				store.dispatch(setBatch(response.data));

				setTimeout(() => {
					var goTopaymentDetails = document.getElementById('goTopaymentDetails');
					goTopaymentDetails.click();
				}, 300);

			}).catch(error => {

				if (error.message.includes("401")) {
					tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
				}

			});
		} else {
			alert("Select at least one biller")
		}





	}


	render() {
		return (
			<div>
				<div class="main">
					<LeftMenu />
					<Link to='/payment-details'>
						<button id="goTopaymentDetails"
							hidden={true}></button>
					</Link>

					<div class="right-side">
						<div class="container-fluid">

							<Header />
							<div class="row">
								<div class="col-12">
									<div class="card">
										<div class="dashhead">
											<h3>Bill Payment Review</h3>
											<div class="backbtn">
												<Link to='/dashboard'>
													<button type="button" class="back" >Back</button>
												</Link>
											</div>
										</div>

										<div class="payreview">
											<div class="table-responsive">
												<table class="table table-bordered">

													<thead>
														<tr>
															<td width="150">Bill Pay Amount:</td>
															<td>₹ {parseFloat(this.props.selectedAmount).toFixed(2)}</td>
														</tr>
														<tr>
															<td>Surcharge:</td>
															<td>₹ 0</td>
														</tr>
														<tr>
															<td>Bill Count</td>
															<td>{this.props.selectedConsumers.length}</td>
														</tr>

														<tr>
															<td>Total Amount</td>
															<td>₹ {parseFloat(this.props.selectedAmount).toFixed(2)}</td>
														</tr>
													</thead>
												</table>
											</div>

											<div class="form-check">
												<input class="form-check-input" type="checkbox" value="" id="pay" checked />
												<label class="form-check-label" for="pay">Total Amount to be deducted from Available Balance - <strong>₹{parseFloat(this.props.selectedAmount).toFixed(2)}</strong></label>
											</div>

											<button type="button" class="btn midbtn" onClick={this.paymentDetails}>Pay Now</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="footer-txt">Copyright &copy; 2021 All rights reserved.
					<br />Powered by FinXpay Solutions Pvt. Ltd.</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, selectedAmount, currentBatch, agentInfo, token, selectedConsumers, clientRole,clientRequesterId } }
) => ({
	errorMessage, loginErrorMessage, phone, selectedAmount, currentBatch, agentInfo, token,
	selectedConsumers, clientRole,clientRequesterId
});

export default connect(mapStateToProps, null)(Payment);
